import { jsxs, jsx } from 'react/jsx-runtime';
import { Trans } from '@lingui/react';
import { button } from '@tecsinapse/cortex-core';
import { Button, Loading } from '@tecsinapse/cortex-react';
import { useState } from 'react';

const Footer = ({
  linkPortal,
  onCloseNotifications
}) => {
  const [loading, setLoading] = useState(false);
  const handleRead = async () => {
    setLoading(true);
    try {
      await onCloseNotifications();
    } finally {
      setLoading(false);
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex justify-between items-center p-mili hover:bg-secondary-light hover:cursor-pointer gap-x-deca", children: [
    /* @__PURE__ */ jsx("a", { className: button({
      className: "flex-1 no-underline"
    }), href: `${linkPortal}/notificacoes`, target: "_self", children: /* @__PURE__ */ jsx(Trans, { .../*i18n*/
    {
      id: "8b7AZk"
    } }) }),
    /* @__PURE__ */ jsxs(Button, { variants: {
      className: "flex-1",
      variant: "outline"
    }, onClick: handleRead, disabled: loading, children: [
      loading ? /* @__PURE__ */ jsx(Loading, {}) : null,
      /* @__PURE__ */ jsx(Trans, { .../*i18n*/
      {
        id: "Oe3qd7"
      } })
    ] })
  ] });
};

export { Footer };
